<template>
  <div class="color-input-wrapper" ref="wrapper">
    <div class="color-input" @click="togglePicker">
      <span class="color-swatch" :style="{ background: currentColor }"></span>
      <span class="color-hex">{{ currentColor || '#000000' }}</span>
      <fa-icon icon="chevron-down" class="color-chevron" />
    </div>
    <div class="color-picker-popup" v-if="pickerOpen">
      <chrome-picker :value="currentColor" @input="handleChange" />
    </div>
  </div>
</template>

<script>
import { Chrome } from "vue-color";

export default {
  name: "ColorInput",
  components: { "chrome-picker": Chrome },
  props: {
    value: { type: String, default: "#000000" },
  },
  data() {
    return {
      pickerOpen: false,
    };
  },
  computed: {
    currentColor() {
      return this.value || "#000000";
    },
  },
  methods: {
    togglePicker() {
      this.pickerOpen = !this.pickerOpen;
    },
    handleChange(color) {
      this.$emit("input", color.hex);
    },
    onDocumentClick(e) {
      if (this.$refs.wrapper && !this.$refs.wrapper.contains(e.target)) {
        this.pickerOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener("mousedown", this.onDocumentClick);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.onDocumentClick);
  },
};
</script>

<style scoped>
.color-input-wrapper {
  position: relative;
}

.color-input {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 10px;
  height: 35px;
  border: 1px solid #d8dbe0;
  border-radius: 4px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s;
  font-size: 13px;
}

.color-input:hover {
  border-color: #b0bec5;
}

.color-swatch {
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  flex-shrink: 0;
}

.color-hex {
  flex: 1;
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 13px;
  color: #344054;
  text-transform: uppercase;
}

.color-chevron {
  font-size: 10px;
  color: #98a2b3;
  flex-shrink: 0;
}

.color-picker-popup {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  z-index: 100;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  overflow: hidden;
}
</style>
